import { useEffect, useState } from 'react';
import './styles/App.css';
import Airtable, { FieldSet, Records } from "airtable";
import AirMeltPage from './AirMeltPage';
import VacuumPage from './VacuumPage';

const apiKey = "patOVIKIQaI8mXtgn.e676990c0d8793501276e18e91ec52d48a16b7ba3abc403bc3bd63726c2edc00"; 
const baseID = "appikIzJCiNEUmIQA"; 

const base = new Airtable({ apiKey: apiKey }).base(baseID);

export function AirMelt() {
  const [airMeltRecords, setAirMeltRecords] = useState<Records<FieldSet>>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await base("air_melt_alloys")
        .select()
        .all();

      setAirMeltRecords(data);
    }
  
    fetchData()
      // TODO error catching
      .catch(console.error);
  }, [])

  return (
    <AirMeltPage records={airMeltRecords} />
  );
}

export function Vacuum() {
  const [vacuumRecords, setVacuumRecords] = useState<Records<FieldSet>>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await base("vacuum_alloys")
        .select()
        .all();

      setVacuumRecords(data);
    }
  
    fetchData()
      // TODO error catching
      .catch(console.error);
  }, [])

  return (
    <VacuumPage records={vacuumRecords} />
  );
}
